import { JUDGEMENT_DOT_STYLES } from '@/features/ai-matching-results/lib/judgementDotStyles';
import type { Judgement } from '@/features/ai-matching-results/lib/types';
import { cn } from '@/shared/lib/utils';

type Props = {
  judgement: Judgement;
  label: string;
};

/**
 * 【デザイン比較用】判定ラベルの先頭に色付きドットを表示する（Google Chat ステータス風）。
 *
 * Select の option label / 選択値の表示に使う。
 */
export const JudgementDotLabel = ({ judgement, label }: Props) => (
  <span className="inline-flex items-center gap-2">
    <span className={cn('size-2.5 shrink-0 rounded-full', JUDGEMENT_DOT_STYLES[judgement])} />
    {label}
  </span>
);
